/**
 * @author Trendrating <info@trendrating.net>
 *
 * @module api/compute/CombinedProducts
 * @summary Requests for Combined Strategies
 *
 */

import { _StoredObjects } from "../_StoredObjects";

export class CombinedProducts extends _StoredObjects {
    storedObjectType = "COMBINED_PRODUCT" as const;

    getPrototype() {
        return {
            benchmark: null,
            currency: null,
            id: null,
            name: null,
            period: null,
            product1: {
                id: null,
                value: 0,
            },
            product2: {
                id: null,
                value: 0,
            },
            type: this.storedObjectType,
        };
    }
}